































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SlidePreviewTail from 'components/presenter/item/topic/viewer/PreviewTail.vue'

@Component({
  components: {
    // Swiper,
    // SwiperSlide,
    SlidePreviewTail
  }
})
export default class ItemTopicViewerSlidesViewerThumbnails extends Vue {

  // options = {
  //   allowTouchMove: true,
  //   slidesPerView: 'auto',
  //   spaceBetween: 4,
  //   freeMode: true
  // }

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly currSlideId!: string

  @Prop()
  readonly seed!: string | undefined

  @Prop({ default: () => { return {} } })
  readonly params!: Json

  @Prop({ default: () => { return {} } })
  readonly response!: Json

  get currSlideIndex () {
    return this.slides.findIndex((s: Json) => ''+s.id === ''+this.currSlideId)
  }

  get prevSlide () {
    if (this.currSlideIndex > 0) {
      return this.slides[ this.currSlideIndex - 1 ]
    } else {
      return null
    }
  }

  get nextSlide () {
    if (this.currSlideIndex < this.slides.length - 1) {
      return this.slides[ this.currSlideIndex + 1 ]
    } else {
      return null
    }
  }

  get progress () {
    return (this.currSlideIndex + 1) / Math.max(1, this.slides.length)
  }

  select (slide: Json) {
    if (slide) {
      this.$emit('slide-select', slide.id)
    }
  }
}
